import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const TOGGLE_FILTERING_RULE: TypedDocumentNode<Data, { input: Variables }> = gql`
  ${ERROR_FRAGMENT}

  mutation toggleFilteringRule($input: UpdateFilteringRuleInput!) {
    updateFilteringRule(input: $input) {
      errors {
        ...ErrorFragment
      }
    }
  }
`
